export const SKELETON_MIN_DURATION_MS = 500;
